/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Toggle_Aria_LabelInputs */

const en_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Notes`)
};

const fr_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer les notes`)
};

const de_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen umschalten`)
};

const it_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva note`)
};

const ru_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать примечания`)
};

const es_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar notas`)
};

const zh_cn2_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换备注`)
};

const ja_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ノートを切り替える`)
};

const hi_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स टॉगल करें`)
};

const pt_pt2_event_notes_toggle_aria_label = /** @type {(inputs: Event_Notes_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar notas`)
};

/**
* | output |
* | --- |
* | "Toggle Notes" |
*
* @param {Event_Notes_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_toggle_aria_label = /** @type {((inputs?: Event_Notes_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_toggle_aria_label(inputs)
	if (locale === "de") return de_event_notes_toggle_aria_label(inputs)
	if (locale === "it") return it_event_notes_toggle_aria_label(inputs)
	if (locale === "ru") return ru_event_notes_toggle_aria_label(inputs)
	if (locale === "es") return es_event_notes_toggle_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_toggle_aria_label(inputs)
	if (locale === "ja") return ja_event_notes_toggle_aria_label(inputs)
	if (locale === "hi") return hi_event_notes_toggle_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_toggle_aria_label(inputs)
	return en_event_notes_toggle_aria_label(inputs)
});